
import { defineComponent, PropType } from 'vue'
import { iDataset } from './KnDatasetList'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import KnDatasetListDescriptor from './KnDatasetListDescriptor.json'

export default defineComponent({
    name: 'datasets-catalog-datatable',
    components: { Column, DataTable, Dialog },
    props: {
        items: [] as PropType<Array<iDataset>>,
        visibility: Boolean
    },
    emits: ['selected', 'save', 'cancel'],
    data() {
        return {
            KnDatasetListDescriptor,
            datasets: [] as iDataset[],
            filteredDatasets: [] as iDataset[],
            selectedDataset: {},
            searchWord: '',
            loading: false,
            isDatasetSelected: false
        }
    },
    updated() {
        if (this.items) this.datasets = this.items
        this.filteredDatasets = [...this.datasets]
    },
    methods: {
        apply(): void {
            this.$emit('save', this.selectedDataset)
            this.clearForm()
        },
        cancel(): void {
            this.$emit('cancel', this.selectedDataset)
            this.clearForm()
        },
        clearForm(): void {
            this.selectedDataset = {}
            this.isDatasetSelected = false
        },
        searchDatasets() {
            setTimeout(() => {
                if (!this.searchWord.trim().length) {
                    this.filteredDatasets = [...this.datasets] as any[]
                } else {
                    this.filteredDatasets = this.datasets.filter((tempDataset: any) => {
                        return tempDataset.label.toLowerCase().includes(this.searchWord.toLowerCase()) || tempDataset.name.toLowerCase().includes(this.searchWord.toLowerCase()) || tempDataset.dsTypeCd.toLowerCase().includes(this.searchWord.toLowerCase())
                    })
                }
            }, 250)
        },
        handleClick(data) {
            this.$emit('selected', data)
            this.isDatasetSelected = true
        }
    }
})
